// src/components/Layout.js
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import MobileNavbar from "./MobileNavbar";

const Layout = ({ children, appLoading }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname]);

  return (
    <div className="min-h-screen w-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col">
      
      {/* 🧭 Top Navbar */}
      {!appLoading && (
        <header>
          <Navbar />
        </header>
      )}

      {/* 📄 Page Content */}
      <main className={`flex-1 w-full ${appLoading ? "" : "pb-20"}`}>
        {children}
      </main>

      {/* 📱 Bottom Nav */}
      {!appLoading && (
        <footer className="block md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white">
          <MobileNavbar />
        </footer>
      )}
    </div>
  );
};

export default Layout;
